import React from 'react';
import styles from './TimelineItem.module.css';

const TimelineItem = ({ period, title, role, description, links }) => {
  // Find if there's a link specifically matching the title text
  const titleLink = links?.find(link => link.text === title);
  // Filter out the title link (if found) to process only description links
  const descriptionLinks = links?.filter(link => link !== titleLink);

  // Helper function to render description with inline links
  const renderDescriptionWithLinks = (desc, descLinks) => {
    if (!descLinks || descLinks.length === 0) {
      return desc;
    }

    let result = [desc]; // Start with the full description as the first element

    descLinks.forEach(link => {
      const newResult = [];
      result.forEach(segment => {
        if (typeof segment === 'string') {
          const parts = segment.split(link.text);
          for (let i = 0; i < parts.length; i++) {
            newResult.push(parts[i]);
            if (i < parts.length - 1) {
              // Insert the link component instead of the plain text
              newResult.push(
                <a
                  // Use a more robust key including the segment index if needed
                  key={`${link.text}-${segment}-${i}`}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.inlineLink} // Style for inline links in description
                >
                  {link.text}
                </a>
              );
            }
          }
        } else {
          // If it's already a component (a link from a previous iteration), keep it
          newResult.push(segment);
        }
      });
      result = newResult;
    });

    // Filter out empty strings that might result from splitting
    return result.filter(part => part !== '');
  };

  // Prepare title content: either a link or plain text
  const titleContent = titleLink ? (
    <a
      href={titleLink.url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.titleLink} // Style specifically for title links
    >
      {title}
    </a>
  ) : (
    title
  );

  return (
    <div className={styles.timelineItem}>
      <div className={styles.timeMarker}>
        <div className={styles.marker}></div>
        <div className={styles.period}>{period}</div>
      </div>
      <div className={styles.content}>
        {/* Render the prepared title content (could be a link or text) */}
        <h3 className={styles.title}>{titleContent}</h3>
        <div className={styles.role}>{role}</div>
        {/* Render the description using the helper function with filtered links */}
        <p className={styles.description}>
          {renderDescriptionWithLinks(description, descriptionLinks)}
        </p>
        {/* Old links section remains commented out */}
      </div>
    </div>
  );
};

export default TimelineItem;